import styled from 'styled-components';
import { DoorOpen } from '@styled-icons/boxicons-solid/DoorOpen';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';

export const PlusCircleIcon = styled(PlusCircle)`
  color: #20907F;
  border-radius: .5em;
  width: 1em;
  margin-left: 5px;
  font-weight: bold;
`;

export const SilhouetteIcon = styled.div`
    color: #20907F;
    position: relative;
    margin: auto;
    height: 75px;
    width: 45px;
    overflow: hidden;
    text-align: center;
`;

export const DoorOpenIcon = styled(DoorOpen)`
  margin-top: 12px;
`;

export const Container = styled.div`
  font-family: Helvetica, "Open Sans", sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  span.instruction {
    font-weigth: bold;
  }
`;

export const Card = styled.div`
  background: #f4f4f2;
  margin-bottom: 20px;
`;

export const CardBody = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
